<div class="hero-bg hero-bg-culture">
  <app-navbar/>
</div>
<div class="not-found-container">
  <h1>{{ 'notfound.title' |translate }}</h1>
  <p>{{ 'notfound.content'|translate }}</p>
  <a routerLink="/">{{ 'notfound.goHome'|translate }}</a>
</div>
